export default "__VITE_ASSET__Bpj5br_2__"